<template>
    <div class="container">
        <Progress :stage="6"/>
        <div class="section-paragraph" v-if="language==='zh'" v-html="documentContent"></div>
        <div class="section-paragraph" v-if="language==='en'" v-html="documentContentEn"></div>
        <a-form @submit="handleSubmit" :form="form" class="document-form">
            <a-form-item
                :label="getLabel('DOCUMENT_LABEL1')"
                :labelCol="{ span: language === 'zh' ? 2 : 3 }"
                :wrapperCol="{ span: language === 'zh' ? 22 : 21 }"
                style="margin: 30px 0;"
            >
                <a-input
                    :tabindex="0"
                    size="large"
                    :placeholder="getLabel('DOCUMENT_TIP1')"
                    v-decorator="['title', {rules: [{ required: true, message: getLabel('DOCUMENT_TIP1') }]}]" autocomplete="off"/>
            </a-form-item>
            <div class="document-section">
                <div class="document-header">{{getLabel('DOCUMENT_SECTION_TITLE1')}}</div>
                <div class="document-content">
                    <p class="section-paragraph">{{getLabel('DOCUMENT_REQUIREMENTS_TITLE1')}}：</p>
                    <ol style="margin-left: 20px;">
                        <li class="section-paragraph">{{getLabel('DOCUMENT_REQUIREMENTS1')}}</li>
                        <li class="section-paragraph">{{getLabel('DOCUMENT_REQUIREMENTS2')}}</li>
                        <li class="section-paragraph">{{getLabel('DOCUMENT_REQUIREMENTS3')}}</li>
                        <li class="section-paragraph">{{getLabel('DOCUMENT_REQUIREMENTS4')}}</li>
                        <li class="section-paragraph">{{getLabel('DOCUMENT_REQUIREMENTS5')}}</li>
                    </ol>
                    <div style="margin-top: 20px;" class="clearfix">
                        <Upload
                            :tip="getLabel('DOCUMENT_SECTION_TITLE1')"
                            :uploadType="1"
                            :maxSize="10"
                            accept=".doc,.docx,.pdf"
                            @change="(file) => addFile(file, 'paper')"
                        />
                        <div class="document-panel"
                             v-for="(file,index) in documentObj['paper']"
                             :key="'paper_' + index"
                        >
                            <img v-if="isDoc(file.name)" src="../assets/img/docx.png" />
                            <img v-else src="../assets/img/PPT.png" />
                            {{file.name}}
                            <a-popconfirm
                                :title="getLabel('TIP_DELETE')"
                                @confirm="deleteFile('paper', file.id)"
                                :okText="getLabel('TIP_DELETE_YES')"
                                :cancelText="getLabel('TIP_DELETE_NO')"
                            >
                                <i class="document-docDelete"></i>
                            </a-popconfirm>
                        </div>
                    </div>
                </div>
            </div>
            <div class="document-section">
                <div class="document-header">{{getLabel('DOCUMENT_SECTION_TITLE2')}}</div>
                <div class="document-content">
                    <p class="section-paragraph">{{getLabel('DOCUMENT_REQUIREMENTS_TITLE2')}}：</p>
                    <ol style="margin-left: 20px;">
                        <li class="section-paragraph">{{getLabel('DOCUMENT_REQUIREMENTS1_SUMMARY')}}</li>
                        <li class="section-paragraph">{{getLabel('DOCUMENT_REQUIREMENTS6')}}</li>
                        <li class="section-paragraph">{{getLabel('DOCUMENT_REQUIREMENTS7')}}</li>
                        <li class="section-paragraph">{{getLabel('DOCUMENT_REQUIREMENTS8')}}</li>
                        <li class="section-paragraph">{{getLabel('DOCUMENT_REQUIREMENTS5_1')}}</li>
                    </ol>
                    <div style="margin-top: 20px;" class="clearfix">
                        <Upload
                            :tip="getLabel('DOCUMENT_SECTION_TITLE2')"
                            :uploadType="2"
                            :maxSize="10"
                            accept=".doc,.docx"
                            @change="(file) => addFile(file, 'summary')"
                        />
                        <div class="document-panel"
                             v-for="(file,index) in documentObj['summary']"
                             :key="'summary_' + index"
                        >
                            <img v-if="isDoc(file.name)" src="../assets/img/docx.png" />
                            <img v-else src="../assets/img/PPT.png" />
                            {{file.name}}
                            <a-popconfirm
                                :title="getLabel('TIP_DELETE')"
                                @confirm="deleteFile('summary', file.id)"
                                :okText="getLabel('TIP_DELETE_YES')"
                                :cancelText="getLabel('TIP_DELETE_NO')"
                            >
                                <i class="document-docDelete"></i>
                            </a-popconfirm>
                        </div>
                    </div>
                </div>
            </div>
            <div class="document-section">
                <div class="document-header">{{getLabel('DOCUMENT_SECTION_TITLE3')}}</div>
                <div class="document-content">
                    <p class="section-paragraph">{{getLabel('DOCUMENT_REQUIREMENTS_TITLE3')}}：</p>
                    <ol style="margin-left: 20px;">
                        <li class="section-paragraph">{{getLabel('DOCUMENT_REQUIREMENTS1_PPT')}}</li>
                        <li class="section-paragraph">{{getLabel('DOCUMENT_REQUIREMENTS9')}}</li>
                        <li class="section-paragraph">{{getLabel('DOCUMENT_REQUIREMENTS10')}}</li>
                        <li class="section-paragraph">{{getLabel('DOCUMENT_REQUIREMENTS11')}}</li>
                    </ol>
                    <div style="margin-top: 20px;" class="clearfix">
                        <Upload
                            :tip="getLabel('DOCUMENT_SECTION_TITLE3')"
                            :uploadType="3"
                            :maxSize="20"
                            accept=".ppt,.pptx,.pdf"
                            @change="(file) => addFile(file, 'ppt')"
                        />
                        <div class="document-panel"
                             v-for="(file,index) in documentObj['ppt']"
                             :key="'ppt_' + index"
                        >
                            <img v-if="isDoc(file.name)" src="../assets/img/docx.png" />
                            <img v-else src="../assets/img/PPT.png" />
                            {{file.name}}
                            <a-popconfirm
                                :title="getLabel('TIP_DELETE')"
                                @confirm="deleteFile('ppt', file.id)"
                                :okText="getLabel('TIP_DELETE_YES')"
                                :cancelText="getLabel('TIP_DELETE_NO')"
                            >
                                <i class="document-docDelete"></i>
                            </a-popconfirm>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <a-button type='default' size="large" @click="backToSummary" v-if="isSecondEnter">{{getLabel('TIP_CANCEL')}}</a-button>
                <a-button type='primary' size="large" class="btn-orange" @click="prevStep" v-if="!isSecondEnter">{{getLabel('BUTTON_PREV')}}</a-button>
                <a-button type='default' size="large" @click="skipStep" v-if="!isSecondEnter">{{getLabel('BUTTON_SKIP')}}</a-button>
                <a-button type='primary' size="large" htmlType="submit">{{getLabel('BUTTON_NEXT')}}</a-button>
            </div>
        </a-form>
        <a-modal
                :visible="!viewed_document_dialog"
                title=""
                :width="800"
                :centered="true"
                :closable="false"
                :maskClosable="false"
                :footer="null"
        >
            <p class="document-modalTitle">{{getLabel('DOCUMENT_DIALOG_TITLE')}}</p>
            <p class="document-modalContent">{{getLabel('DOCUMENT_DIALOG_CONTENT1')}}</p>
            <p class="document-modalContent">{{getLabel('DOCUMENT_DIALOG_CONTENT2')}}</p>
            <p class="document-modalContent">{{getLabel('DOCUMENT_DIALOG_CONTENT3')}}</p>
            <p class="document-modalContent" style="margin-top: 8px;">{{getLabel('DOCUMENT_DIALOG_CONTENT4')}}</p>
            <p class="document-modalContent" style="margin-top: 8px;">{{getLabel('DOCUMENT_DIALOG_CONTENT5')}}</p>
            <div style="text-align: center; margin-top: 15px;">
                <a-button type="primary" @click="closeInfoDialog">
                    {{getLabel('DOCUMENT_DIALOG_BUTTON')}}
                </a-button>
            </div>

        </a-modal>
    </div>
</template>

<script>
	import {mapState} from 'vuex';
	import Progress from '../components/Progress';
	import Language from '../util/language';
	import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
	import Upload from '../components/Upload';

	export default {
		components: {
			Progress,
			Upload
		},
		data () {
			return {
				form: this.$form.createForm(this),
				zhCN
			}
		},
		mounted() {
			if (!this.hasData) {
				this.$store.dispatch('document/getDocument');
			} else {
				this.form.setFieldsValue(this.documentObj);
            }
		},
		computed: {
			...mapState({
				language: state => state.main.language,
				residence_city: state => state.main.currentUser.residence_city,
				hasData: state => state.document.hasData,
				documentObj: state => state.document.documentObj,
				isSecondEnter: state => state.main.isSecondEnter,
                documentContent: state => state.main.document_content,
                documentContentEn: state => state.main.document_content_en,
                viewed_document_dialog: state => state.main.currentUser.viewed_document_dialog
			})
		},
		watch: {
			hasData: function () {
				this.form.setFieldsValue(this.documentObj);
			}
		},
		methods: {
			// 获取描述
			getLabel: function (key) {
				return Language(this.language, key);
			},
            // 文档类型判断
			isDoc: function (fileName) {
			    if (
			    	fileName.indexOf('.docx') !== -1 ||
				    fileName.indexOf('.doc') !== -1
                ) {
			    	return true;
                } else {
			    	return false;
                }
            },
            // 上传文件
			addFile: function (file, type) {
				this.$store.commit('document/addFile', {file, type});
			},
            // 删除文件
			deleteFile: function (type, id) {
				let _this = this;
				this.$store.dispatch('main/deleteDocument', {
					id,
					callBack: () => {
						_this.$store.commit('document/deleteFile', {type, id});
					}
				});
            },
			// 上一步
			prevStep: function () {
				const targetModule = this.residence_city === 1 ? 'activity' : 'hotel';
				if (this.language === 'zh') {
					this.$router.push(`/${targetModule}`);
				} else {
					this.$router.push(`/en/${targetModule}`);
				}
			},
			// 跳过
			skipStep: function () {
				this.submitLectureInfo(this.form.getFieldsValue());
			},
			// 下一步
			handleSubmit: function (e) {
				e.preventDefault();
				this.form.validateFields((err, values) => {
					if (!err) {
						this.submitLectureInfo(values)
					}
				})
			},
			// 提交
			submitLectureInfo: function (data) {
				this.$store.dispatch('document/submitLectureInfo', data);
				if (this.language === 'zh') {
					this.$router.push('/summary');
				} else {
					this.$router.push('/en/summary');
				}
			},
			backToSummary: function () {
				this.$store.commit('main/backToSummary');
			},
            // 关闭"与会文件使用说明弹窗"
            closeInfoDialog: function () {
                this.$store.dispatch('main/viewDialog');
            }
		}
	};
</script>

<style lang="less" scoped>
    .document {
        &-header {
            background: #6FD0FF;
            padding-left: 15px;
            font-size: 16px;
            color: #333333;
            height: 40px;
            line-height: 40px;
        }
        &-content {
            padding: 20px 15px;
        }
        &-panel {
            position: relative;
            width: 230px;
            height: 150px;
            background: #F2F2F2;
            border-radius: 4px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            float: left;
            margin-left: 10px;
            margin-bottom: 10px;
            padding: 0 10px;
            font-size: 14px;
            color: #333;
            white-space:normal;
            word-break:break-all;
            &:nth-child(4n + 1) {
                margin-left: 0;
            }
            img {
                width: 78px;
                height: 61px;
                margin-bottom: 10px;
            }
        }
        &-docDelete {
            display: block;
            width: 20px;
            height: 20px;
            position: absolute;
            right: 10px;
            top: 10px;
            background: url(../assets/img/delete_file.png) center center no-repeat;
            background-size: 100%;
            z-index: 10;
            cursor: pointer;
        }
        &-modalTitle {
            text-align: center;
            font-size: 1.2rem;
            margin-bottom: 5px;
        }
        &-modalContent {
            line-height: 2.5;
        }
    }
</style>
